// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2dgL8nb71nRF2_ogQupKNT","portal":"_1i4V1kQVFY62OssheTM89j","portal-non-scrollable":"_3uCb6PZKHTJG8_rzDGLHSf","portalNonScrollable":"_3uCb6PZKHTJG8_rzDGLHSf"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Modal/Modal.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Modal/Modal.scss
// module chunks = 0